"use strict";
// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var SystemReduceLine = { "icon": { "tag": "svg", "attrs": { "viewBox": "32 32 960 960", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M298.67 469.33h426.66Q768 469.33 768 512t-42.67 42.67H298.67Q256 554.67 256 512t42.67-42.67z" } }] }, "name": "system-reduce-line", "theme": "outlined" };
exports.default = SystemReduceLine;
